import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { IMotivoCancelamento } from '../model/motivo-cancelamento.model';

@Injectable()
export class MotivoCancelamentoService extends EntityService<
  IMotivoCancelamento
> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'motivos_cancelamento',
      pluralBaseEntityEndPoint: 'motivos_cancelamento'
    });
    this.entityName = 'motivo_cancelamento';
  }

  override getEntity(id: string, include?: string[]) {
    const url = `${this.baseURL}/${id}`;
    let params = new HttpParams();
    if (include)
      params = params.set(
        'include',
        Array.isArray(include) ? include.join(',') : include
      );
    return this.http.get(url, { headers: this.getHeader(), params }).pipe(
      map(data => {
        return data[this.entityName];
      }),
      catchError(this.handleError)
    );
  }
}
